import { AllowedIds, Option } from "./types";

export const defaultRenderOption = <
  Id extends AllowedIds,
  OptionPayload extends unknown
>(
  option: Option<Id, OptionPayload>
) => option.value;
